import { render, staticRenderFns } from "./TaskInputForm.vue?vue&type=template&id=2b751038"
import script from "./TaskInputForm.vue?vue&type=script&lang=js"
export * from "./TaskInputForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports